import '../assets/NcCheckboxRadioSwitch-BkBep4wT.css';
import { r as register } from "./_l10n-BlIvfB2V.mjs";
register();
